/*
  Emma's Boutique London — smooth uitklappen (30-10-2026)
  Animeert <details> open/dicht in plaats van direct te springen.
  Alleen voor uitklapblokken, NIET voor menu's, zoekvenster of filters:
    - .accordion details   (productpagina: Description / Shipping / Returns, sectie "Uitklapbare inhoud")
    - .ebf details         (FAQ-pagina)
    - details.ebl-smooth   (handmatig toe te voegen class)
  Respecteert "minder beweging" (prefers-reduced-motion): dan gewoon direct open/dicht.
*/
(function () {
  if (window.__eblAccordion) return;
  window.__eblAccordion = true;

  var SELECTOR = '.accordion details, .ebf details, details.ebl-smooth';
  var DURATION = 320;
  var EASING = 'cubic-bezier(.4, 0, .2, 1)';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function finish(details, open) {
    details.open = open;
    details.classList.remove('ebl-acc--closing');
    details.style.height = '';
    details.style.overflow = '';
    details._eblAnim = null;
  }

  function animate(details, open) {
    var summary = details.querySelector(':scope > summary');
    details.style.overflow = 'hidden';
    // Beginhoogte = huidige (ook midden in een lopende animatie), daarna pas annuleren
    var start = details.offsetHeight;
    if (details._eblAnim) details._eblAnim.cancel();

    // Eindhoogte meten in de eindtoestand
    details.open = open;
    details.style.height = 'auto';
    var end = details.offsetHeight;
    details.open = true; // tijdens de animatie open laten zodat de inhoud zichtbaar blijft
    details.style.height = start + 'px';

    details.classList.toggle('ebl-acc--closing', !open);
    if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');

    var anim = details.animate(
      { height: [start + 'px', end + 'px'] },
      { duration: DURATION, easing: EASING }
    );
    details._eblAnim = anim;
    anim.onfinish = function () { if (details._eblAnim === anim) finish(details, open); };
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest('summary');
    if (!summary) return;
    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS' || !details.matches(SELECTOR)) return;
    if (reduceMotion.matches || typeof details.animate !== 'function') return;
    // Links of knoppen ín de summary gewoon laten werken
    if (event.target.closest('a, button') && event.target.closest('a, button') !== summary) return;

    event.preventDefault();
    var opening = details._eblAnim ? details.classList.contains('ebl-acc--closing') : !details.open;
    animate(details, opening);
  });
})();
